import { __makeTemplateObject } from "tslib";
import { css } from '../styled-components';
/**
 * ellipsis style
 *
 * @returns
 * ```css
 * white-space: nowrap;
 * overflow: hidden;
 * text-overflow: ellipsis;
 * ```
 */
export function ellipsis() {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  "], ["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  "])));
}
var templateObject_1;
